/**
 * 全局过滤器定义，已经在main.js中全局引入
 * vue文件中使用方法：
 * {{ text |  FBindStatus}}
 */
const BindStatusMap = {
  1: "未绑定",
  2: "已绑定",
};
const NoworkMap = {
  1: "连续3天",
  2: "连续3-7天",
  3: "连续7天以上",
  4: "累计10天",
  4: "累计10-30天",
  4: "累计30天以上",
};
const SiteStatusMap = {
  1: "施工中",
  2: "未开工",
  3: "合同终止",
  4: "施工结束",
};
const WorkerTypeMap = {
  1: "工程管家",
  2: "项目经理",
  3: "瓦工",
  4: "木工",
  5: "油工",
  6: "水电工",
  7: "其他",
};
const DeviceStatusMap = {
  0: "全部",
  1: "在线",
  2: "离线",
  3: "未启用",
  4: "故障",
  5: "备用",
  6: "入库",
};
const SiteNeatLevelMap = {
  1: "优",
  2: "良",
  3: "差",
};
const AlarmEventsMap = {
  cameraproblem: "摄像头歪曲",
  noclothes: "未穿工服",
  smoking: "有人吸烟",
};
const SiteAttendanceMap = {
  1: "已打卡",
  2: "未打卡",
};
const SiteDeviceStatusMap = {
  1: "在线",
  2: "不在线",
  // 2: "——",
};
// 是否纠正
const SitcorrectStatus = {
  1: "未纠正",
  2: "纠正中",
  3: "已纠正",
  4: "已取消",
};
const SitneatResult = {
  1: "优",
  2: "良",
  3: "差",
  4: "摄像头歪",
};
// 纠正结果
const SitTypeLog = {
  1: "无人吸烟/其它",
  2: "有穿工服/其它",
  3: "摄像头歪曲",
  4: "整洁度（优）",
  5: "整洁度（良）",
  6: "整洁度（差）",
  7: "穿工服",
};
// 原纠正事件
const OldType = {
  1: "有人吸烟",
  2: "未穿工服",
  3: "摄像头歪曲",
  4: "整洁度（优）",
  5: "整洁度（良）",
  6: "整洁度（差）",
  7: "穿工服",
};
const principalWpost = {
  1: "工程管家",
  2: "项目经理",
};
export function FBindStatus(value) {
  return BindStatusMap[value];
}

export function FNowork(value) {
  return NoworkMap[value] ? NoworkMap[value] : "--";
}
export function FSiteStatus(value) {
  return SiteStatusMap[value];
}
export function FWorkerType(value) {
  return WorkerTypeMap[value];
}
export function FDeviceStatus(value) {
  return DeviceStatusMap[value];
}
export function SiteNeatLevel(value) {
  return SiteNeatLevelMap[value];
}
export function AlarmEvents(value) {
  return AlarmEventsMap[value];
}
export function SiteAttendance(value) {
  return SiteAttendanceMap[value];
}
export function SiteDeviceStatus(value) {
  return SiteDeviceStatusMap[value];
}

export function SitCorrectStatus(value) {
  return SitcorrectStatus[value];
}
// 工地整洁度
export function SitNeatResult(value) {
  return SitneatResult[value];
}
// 纠正事件;
export function sitTypeLog(value) {
  return SitTypeLog[value];
}
// 原纠正事件
export function oldType(value) {
  return OldType[value];
}
export function PrincipalWpost(value) {
  return principalWpost[value];
}
